import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSidebar } from '@fortawesome/pro-light-svg-icons/faSidebar';
import { TypedMemo } from '../../../common/types';
import { smlNavigationChromeMessages as messages } from '../smlNavigationMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole sidebar; each part uses its own slice of it */
import styles from '../../SMLSideBar.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SidebarRailButtonProps {
  isRail: boolean;
  onToggleRail: () => void;
}

/**
 * design: navigation-v2 1a, 1f (nav2.css .ghost-btn). Collapse in the brand row of the full
 * sidebar, expand at the bottom of the rail. From 769 to 1199 px the rail is the only layout, so
 * the CSS hides the button there.
 */
const SidebarRailButtonComponent: React.FC<SidebarRailButtonProps> = ({ isRail, onToggleRail }) => {
  const intl = useIntl();
  const label = intl.formatMessage(isRail ? messages.expand : messages.collapse);
  return (
    <button
      type="button"
      className={styles.railButton}
      onClick={onToggleRail}
      aria-pressed={isRail}
      aria-label={label}
      title={label}
    >
      <FontAwesomeIcon icon={faSidebar} />
    </button>
  );
};

export const SidebarRailButton = TypedMemo(SidebarRailButtonComponent);
